import { useEffect } from 'react';

export function useMount(callback) {
  return useEffect(callback, []);
}
